/**
 * xs (0px - 599px) will be the base/default breakpoint
 */
export const breakpoints = {
  sm: '600px',
  md: '850px',
  lg: '1280px',
  xl: '1536px',
}
